import { GAME_KEYS, SCHOOL_GROUPS } from '@oefy/core';
import { z } from 'zod';

export const schoolGroupSchema = z.literal(SCHOOL_GROUPS);
export const gameKeySchema = z.enum(GAME_KEYS);
export const timestampSchema = z.iso.datetime();
export const idParamsSchema = z.object({ id: z.uuid() });

export const pageQuery = {
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(100).default(25),
};

export const pageFields = { total: z.int(), page: z.int(), pageSize: z.int() };
